// extracted by mini-css-extract-plugin
export default {"root":"Z9J75L","picture":"sURwHJ","text":"LV0gIW"};